module.exports = __webpack_public_path__ + "media/earth.b80d295c.mp4";